import { AddedSearchFilters } from '../SearchState';
import { RootState } from '../../RootState';

const selectLastAddedProductFilters = (state: RootState): AddedSearchFilters | undefined =>
  state.search.addedSearchFilters.at(-1);

export default selectLastAddedProductFilters;
